import { Info } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { PLANS, TIMELINE } from "../data/proposal";
import { SectionHead } from "./SectionHead";

const Timeline = () => (
  <ol className="mt-10 grid gap-6 md:grid-cols-3">
    {TIMELINE.map((t, i) => (
      <li key={t.month} data-testid={`timeline-${i}`} className="relative border-t-4 border-[var(--blue)] pt-5">
        <span className="absolute -top-[10px] left-0 h-4 w-4 rounded-full border-4 border-white bg-[var(--blue)]" />
        <p className="text-sm font-black text-[var(--blue)]">{t.month}</p>
        <p className="mt-1 text-lg font-black text-[var(--ink)]">{t.title}</p>
        <p className="mt-1 text-sm text-[var(--text)]">{t.text}</p>
      </li>
    ))}
  </ol>
);

const List = ({ title, items }) => (
  <div>
    <p className="text-sm font-black text-[var(--ink)]">{title}</p>
    <ul className="mt-2 space-y-1 text-sm text-[var(--text)]">{items.map((x) => <li key={x}>・{x}</li>)}</ul>
  </div>
);

const Plans = () => (
  <Accordion type="multiple" className="mt-12 rounded-2xl border border-[var(--line)] bg-white px-6">
    {PLANS.map((p) => (
      <AccordionItem key={p.id} value={p.id} className="border-[var(--line)] last:border-0">
        <AccordionTrigger data-testid={`plan-toggle-${p.id}`} className="text-left text-base font-black text-[var(--ink)] hover:no-underline md:text-lg">
          方案細節｜{p.name}
        </AccordionTrigger>
        <AccordionContent data-testid={`plan-content-${p.id}`}>
          <p className="text-sm text-[var(--text)]">對象：{p.target}{p.price && `｜${p.price}`}</p>
          <div className="mt-4 grid gap-6 md:grid-cols-2">
            <List title="宣傳亮點" items={p.highlights} />
            <List title="待確認事項" items={p.pending} />
          </div>
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const Schedule = () => (
  <section id="schedule" data-testid="schedule-section" className="bg-[var(--warm)]">
    <div className="mx-auto max-w-6xl px-5 py-20">
      <SectionHead no="06" title="排程" sub="10 月啟動，12 月中完成" />
      <Timeline />
      <Plans />
      <p data-testid="observation-note" className="mt-8 flex items-start gap-2 text-sm text-[var(--text)]">
        <Info size={16} className="mt-0.5 shrink-0 text-[var(--blue)]" />
        上線後 1–2 週為初步觀察期，不保證這段時間內一定有訂單。
      </p>
    </div>
  </section>
);
